import Head from 'next/head';
import Typography from '@material-ui/core/Typography';
import MLink from '@material-ui/core/Link';
import { buildTitle } from '../utils/layout';
import config from '../config';
import Main from '../components/main';
import MaterialLink from '../components/material-link';
import SupportBanner from '../components/support-banner';

const About = () => {
  return (
    <Main>
      <Head>
        <title>{buildTitle('About')}</title>
        <link rel="canonical" href={`${config().universal.baseUri}/about`} />
      </Head>

      <Typography variant="h1">About Everyday Rides</Typography>

      <p>
        Everyday Rides is a free space for the cycling community to find and organize social rides and bike events. Everyday Rides encourages the promotion of inclusive and welcoming rides and events by making events easy to find and encouraging transparency in event listings.
      </p>

      <p>
        In addition to the public calendar, events and community updates are regularly shared on
        {' '}
        <MLink
          href="https://www.instagram.com/everydayridescom"
        >
          Instagram (@everydayridescom)
        </MLink>
        {' and the '}
        <MLink
          href="https://blog.everydayrides.com"
        >
          Everyday Rides Blog
        </MLink>
        .
      </p>

      <Typography variant="h2">About The Calendar</Typography>

      <p>
        The Everyday Rides Calendar is a free to use public calendar that anyone can post to. Rides and events are posted to the calendar by users and are not sponsored by Everyday Rides.
      </p>

      <Typography variant="h3">Registering for Rides and Events</Typography>

      <p>
        Most rides and events are free, but some require registration or a fee to join. Read the event description fully or follow the &quot;More Info&quot; link to make sure.
      </p>

      <Typography variant="h3">Adding Rides and Events</Typography>

      <p>
        Anyone can
        {' '}
        <MaterialLink href="/events/new">
          add their own events
        </MaterialLink>
        {' '}
        for free once they&apos;ve signed up for an account. If you&apos;re part of a club or group, you can create or join a group and post events for group members.
      </p>

      <p>Events can be posted publicly on the city calendar, just for members of a group, unlisted (shareable with link), or completely private and only accessible via email invite.</p>

      <p>Rides and Events (both online and offline) can be added to the site. All rides and events are welcome as long as they involve or relate to bicycles. If a ride requires registration or payment, please specify in the event listing and choose the correct associated categories.</p>

      <Typography variant="h3">Groups and User Accounts</Typography>

      <p>One of the great features of Everyday Rides is that registered users (free!) can join groups and follow hosts to get notified when new events and updates are posted.</p>

      <Typography variant="h3">Email Notifications</Typography>

      <p>As a registered user, you will automatically receive the following emails. All emails can be unsubscribed from.</p>

      <ul>
        <li>General: Weekly emails twice a week on Sundays afternoons and Friday mornings with upcoming events for the week and weekend. (manage in your account)</li>
        <li>Groups: New event emails, new group post emails, and comments on events and posts you&apos;re participating in from groups you&apos;re a member of (manage in each group).</li>
        <li>People: New event emails for people you&apos;re following (manage on people profiles).</li>
        <li>Events: New comment notifications for events you&apos;re RSVP&aspo;d to or commenting on (manage on each event).</li>
        <li>Marketing: If you selected when you signed up (or changed in your account settings), you will also receive occasional news and updates about Everyday Rides.</li>
        <li>Admin: Some administrative emails will be sent for updates to your account or to notify you of requests to join groups or events you manage.</li>
      </ul>

      <Typography variant="h2">Staff</Typography>

      <p>
        Everyday Rides is built and maintained by
        {' '}
        <MLink href="http://zachhale.com">Zach Hale</MLink>
        , a cyclist and software developer living in Seattle, WA.
      </p>

      <Typography variant="h2">Support Everyday Rides</Typography>

      <SupportBanner />

      {/* <p>
        Everyday Rides is a passion project for me and I could use your support for running the site and for continued development. Any support you can give makes a huge difference. Thank you!
      </p>

      <div className={classes.donateButtons}>
        <Button
          href="https://www.patreon.com/bePatron?u=28468188"
          variant="contained"
          color="primary"
        >
          Become a Patron!
        </Button>

        <Button
          href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=MCW62PKB3CL9E&source=url"
          variant="contained"
          color="primary"
        >
          Donate on PayPal
        </Button>
      </div> */}

      <Typography variant="h2">Help and Feedback</Typography>

      <p>
        Send a message using the chat bubble at the bottom right of the site or
        {' '}
        <MLink href="mailto:support@everydayrides.com">reach out via email</MLink>
        {' '}
        if you have any questions, feedback, or just want to get in touch.
      </p>
    </Main>
  );
};

export default About;
